// The locked master palette. Every sprite colour comes from here.
// Each ramp runs dark -> mid -> light -> highlight. Light comes from the top left.
export const RAMPS = {
  frost: ['#3a4a6b', '#6a7fa8', '#a9bddb', '#e6f0fa'],
  ice: ['#2b6f9e', '#5fc8f0', '#a8ecff', '#e8fdff'],
  snow: ['#9aa3b5', '#c9d1de', '#dfe6f0', '#ffffff'],
  flame: ['#7a2418', '#c94a1e', '#f08a2c', '#ffd36b'],
  gold: ['#7a3f1e', '#c7832e', '#f0c45a', '#fff1b8'],
  grove: ['#23452a', '#3f7a3a', '#79b04a', '#c6e07a'],
  earth: ['#3d2a22', '#6b4a35', '#9a7050', '#c9a27a'],
  stone: ['#3b3a40', '#66646b', '#9a979c', '#cfcdcf'],
  tide: ['#1d3a63', '#2f6aa3', '#4fa3d6', '#9fe0f2'],
  storm: ['#2e2452', '#5a46a0', '#8f7ae0', '#cdbfff'],
  shade: ['#1e1a2b', '#3a2f4f', '#625078', '#9a86ad'],
  light: ['#8a6d3b', '#d4b25c', '#f5e6a8', '#fffbe8'],
  blood: ['#5a1a24', '#a32f3a', '#e05a5a', '#ffb0a8'],
  skin: ['#7a4a4a', '#b8746a', '#e3a790', '#f7d6c4'],
  cream: ['#b89a6a', '#e8d4a8', '#fff6dc', '#fffdf4'],
  violet: ['#4a1f66', '#8a3fc4', '#b46cff', '#f1dcff'],
} as const satisfies Record<string, readonly [string, string, string, string]>;

export type RampName = keyof typeof RAMPS;

export const SINGLES = {
  ink: '#1b2238', // outline for normal sprites
  auraInk: '#2a1636', // outline for aura sprites
  eye: '#10131f',
  white: '#ffffff',
} as const;

export type SingleName = keyof typeof SINGLES;

/** 'frost.2' or 'eye' */
export type ColorRef = `${RampName}.${0 | 1 | 2 | 3}` | SingleName;

export function resolveColor(ref: ColorRef, swap: Partial<Record<RampName, RampName>> = {}): string {
  if (ref in SINGLES) return SINGLES[ref as SingleName];
  const [ramp, idx] = ref.split('.') as [RampName, string];
  const target = swap[ramp] ?? ramp;
  return RAMPS[target][Number(idx)];
}
